import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1';

export interface PlatformSettings {
  currency_code: string;
  currency_symbol: string;
  currency_name: string;
  platform_name: string;
}

interface PlatformSettingsState {
  settings: PlatformSettings | null;
  loading: boolean;
  error: string | null;
}

const initialState: PlatformSettingsState = {
  settings: null,
  loading: false,
  error: null,
};

// Fetch public platform settings
export const fetchPlatformSettings = createAsyncThunk(
  'platformSettings/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/platform-settings/public`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.detail || 'Failed to fetch platform settings');
    }
  }
);

const platformSettingsSlice = createSlice({
  name: 'platformSettings',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlatformSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlatformSettings.fulfilled, (state, action: PayloadAction<PlatformSettings>) => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(fetchPlatformSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = platformSettingsSlice.actions;
export default platformSettingsSlice.reducer;
